module.exports = __webpack_public_path__ + "static/media/mu.84ff7cbd.svg";